import * as FI from 'react-icons/fi'
import MenuMobile from '../MenuMobile'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import Styled from './header.module.css'
import { useLandingContext } from '../../Context'
import * as Scroll from 'react-scroll';

const Header = () => {
    const [toggleMenu, setToggleMenu] = useState(false)

    return (
        <>
            {toggleMenu && <MenuMobile updateState={setToggleMenu} />}
            <header className={Styled.container_header}>
                <Link to="/" className={Styled.container_logo}>
                    <img className={Styled.logo} src={useLandingContext().websiteSettings.logo.url} alt="Logo" />
                </Link>
                <nav className={Styled.nav_links}>
                    <Scroll.Link to="inicio" smooth={true} >Inicio</Scroll.Link>
                    <Scroll.Link to="curriculo" smooth={true}>Currículo</Scroll.Link>
                    <Scroll.Link to="servicos" smooth={true}>Serviços</Scroll.Link>
                    <Scroll.Link to="depoimentos" smooth={true}>Depoimentos</Scroll.Link>
                    <a rel="noreferrer" target="_blank" href={useLandingContext().websiteSettings.blog}>Blog</a>
                    <Scroll.Link to="contato" smooth={true}>Contato</Scroll.Link>
                    <Link to="/private/login">
                        <FI.FiLogIn />
                    </Link>
                </nav>
                <button onClick={() => setToggleMenu(true)} className={Styled.btn_bars} type="button">
                    <FI.FiAlignJustify />
                </button>
            </header>
        </>
    )
}

export default Header